import { useEffect, useState } from "react";
import { api } from "../api";
import { Brand } from "../components/Brand";
import { Spinner } from "../components/Spinner";

export function QrPage({ code }: { code: string }) {
  const [state, setState] = useState<{
    loading: boolean;
    valid: boolean;
    event?: { name: string; city: string };
    message?: string;
  }>({ loading: true, valid: false });

  useEffect(() => {
    if (!code) {
      setState({ loading: false, valid: false });
      return;
    }
    void api<{ valid: boolean; event?: { name: string; city: string }; message: string }>(
      `/api/q/${encodeURIComponent(code)}`,
    )
      .then((result) => setState({ loading: false, ...result }))
      .catch(() => setState({ loading: false, valid: false }));
  }, [code]);

  return (
    <main className="center-screen qr-public-page">
      <Brand />
      {state.loading ? (
        <Spinner label="正在验证二维码" />
      ) : state.valid ? (
        <section className="card">
          <span className="large-check">✓</span>
          <span className="eyebrow">VALID FIELD PASS</span>
          <h1>{state.event?.name ?? "Ingress First Saturday"}</h1>
          <p>{state.message}</p>
          <a className="button button--primary" href="/admin/scan">
            打开核验员 Scanner
          </a>
        </section>
      ) : (
        <section className="card">
          <span className="large-check large-check--bad">×</span>
          <h1>二维码无效</h1>
          <p>该二维码不存在、已撤销或内容不完整。</p>
          <a className="button button--ghost" href="/">
            返回活动页面
          </a>
        </section>
      )}
    </main>
  );
}
